/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * PostHog API - 1 ops
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod'

export const ExperimentResultsWidgetConfig = /* @__PURE__ */ zod.object({
    experimentId: zod
        .union([zod.number(), zod.null()])
        .optional()
        .describe('Experiment to show results for. Null until the user picks one in the widget settings.'),
})

export type ExperimentResultsWidgetConfig = zod.input<typeof ExperimentResultsWidgetConfig>
export type ExperimentResultsWidgetConfigOutput = zod.output<typeof ExperimentResultsWidgetConfig>
